import { memo } from "react";
import { GRID_ACTIONS_COLUMN_TYPE, GridRowParams } from "@mui/x-data-grid";
import type { ResourceResponse } from "types";
import { TableGridMode } from "consts/table";
import { Filters, MenuItem } from "consts/openBanking";
import { FilterVariant } from "consts/filters";
import {
    selectOpenBankingResourceSlice,
    selectIsOpenBankingResourceLoading
} from "features/openBanking/selectors";
import { useBankingSDKConnectorsRecipientsPivotActions } from "features/openBanking/actions";
import { BankingSdkConnectorsRecipientsPivot } from "features/openBanking/types";
import { useSimpleSwitch } from "ui/widgets/Table";
import useBankingSDKConnectorsRecipientsPivot from "./useBankingSDKConnectorsRecipientsPivot";
import BankingSDKConnectorsRecipientsPivotDetail from "./BankingSDKConnectorsRecipientsPivotDetail";
import BankingSDKConnectorsRecipientsPivotToolbar from "./BankingSDKConnectorsRecipientsPivotToolbar";
import { OpenBankingResource, EditOpenBankingResource } from "../shared";
import { DeleteBankingSDKConnectorsRecipientsPivot } from "./actions";

const BankingSDKConnectorsRecipientsPivot = () => {
    const {
        updateBankingSDKConnectorsRecipientsPivot
    } = useBankingSDKConnectorsRecipientsPivotActions();

    return (
        <OpenBankingResource
            BreadcrumbsProps={{
                heading: 'Banking SDK Connectors Recipients Pivot'
            }}
            ResourceProps={{
                name: 'Banking SDK Connectors Recipients Pivot',
                useResource: useBankingSDKConnectorsRecipientsPivot,
                mode: TableGridMode.OpenBankingBankingSDKConnectorsRecipientsPivot,
                selectIsTableUninitialized: () => true,
                // selectIsOpenBankingResourceUninitialized(MenuItem.BankingSDKConnectorsRecipientsPivot),
                selectIsTableLoading: selectIsOpenBankingResourceLoading(MenuItem.BankingSDKConnectorsRecipientsPivot),
                selectTableDataSlice: selectOpenBankingResourceSlice(MenuItem.BankingSDKConnectorsRecipientsPivot),
                Toolbar: BankingSDKConnectorsRecipientsPivotToolbar,
                Detail: BankingSDKConnectorsRecipientsPivotDetail,
                CellProps: {
                    [Filters.isEnabled]: useSimpleSwitch({
                        handleChangeRequest: changePayload => {
                            const [request] = updateBankingSDKConnectorsRecipientsPivot(changePayload);

                            return request as Promise<ResourceResponse<BankingSdkConnectorsRecipientsPivot>>;
                        }
                    })
                },
                columns: [
                    {
                        field: GRID_ACTIONS_COLUMN_TYPE,
                        type: GRID_ACTIONS_COLUMN_TYPE,
                        getActions: (params: GridRowParams) => [
                            <EditOpenBankingResource
                                key='edit'
                                {...params}
                            />,
                            <DeleteBankingSDKConnectorsRecipientsPivot
                                key='delete'
                                {...params}
                            />
                        ]
                    }
                ],
                filterTypes: new Map<FilterVariant, string[]>([
                    [FilterVariant.Text, [Filters.paymentProduct]],
                    [FilterVariant.SingleOption, [Filters.isEnabled]],
                ])
            }}
        />
    );
};

export default memo(BankingSDKConnectorsRecipientsPivot);
